/** Box ships monochrome from @air/design-icons; brand colour is applied at render sites. */
export const BOX_ICON_COLORS = {
  hex: '#0061D5',
  className: 'text-[#0061D5]',
} as const;

/** Dropbox ships monochrome from @air/design-icons; brand colour is applied at render sites. */
export const DROPBOX_ICON_COLORS = {
  hex: '#0061FF',
  className: 'text-[#0061FF]',
} as const;
